import {ref, computed} from "vue";
import {useOnline} from "@vueuse/core";
import {useUser} from "@clerk/vue";

export default function useUserSafe() {
  const isClient = typeof window !== "undefined";
  const isClerkEnabled = isClient && window.__clerkEnabled === true;
  const online = isClient ? useOnline() : ref(false);
  const offlineResponse = {
    isLoaded: ref(true),
    isSignedIn: ref(false),
    user: ref(null)
  };
  const baseUser = isClient && isClerkEnabled ? useUser() : offlineResponse;
  const effectiveIsLoaded = computed(() => {
    if (!isClient) return true;
    if (!online.value) return true;
    if (!baseUser.isLoaded) return false;
    return baseUser.isLoaded.value;
  });
  const effectiveIsSignedIn = computed(() => {
    if (!effectiveIsLoaded.value) return false;
    if (!baseUser.isSignedIn) return false;
    return !!baseUser.isSignedIn.value;
  });
  const effectiveUser = computed(() => {
    if (!effectiveIsSignedIn.value) return null;
    if (!baseUser.user) return null;
    return baseUser.user.value || null;
  });
  return {
    isLoaded: effectiveIsLoaded,
    isSignedIn: effectiveIsSignedIn,
    user: effectiveUser
  };
}
